import React from 'react';
import RoomDependentWrapperPage from '@common/components/Room/RoomSelectors/RoomDependentWrapperPage';
import MissionsGrid from '@common/components/Room/Missions/MissionsGrid';

const MissionsPage: React.FC = () => {
  return (
    <React.Fragment>
      <RoomDependentWrapperPage>
        <MissionsGrid />
      </RoomDependentWrapperPage>
    </React.Fragment>
  );
};

export default MissionsPage;
